// components/NoNavPage.tsx
import { ReactNode } from "react";
import { useState, useEffect } from "react";

import { Sun as SunIcon, Moon as MoonIcon } from "lucide-react";

import Logo from "@/assets/aptfleet-custom.svg";
import { ReactSVG } from "react-svg";
import CookieConsent from "@/components/CookieConsent";

interface PageProps {
  title: string;
  children: ReactNode;
}

const NoNavPage = ({ title, children }: PageProps) => {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    // Check for saved theme preference or use system preference
    const savedTheme = localStorage.getItem("theme");
    const systemTheme = window.matchMedia("(prefers-color-scheme: dark)")
      .matches
      ? "dark"
      : "light";
    const theme = savedTheme || systemTheme;

    if (theme === "dark") {
      document.documentElement.classList.add("dark");
      setDarkMode(true);
    }
  }, []);

  const toggleTheme = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    document.documentElement.classList.toggle("dark");
    localStorage.setItem("theme", newDarkMode ? "dark" : "light");
    window.dispatchEvent(new StorageEvent("TriggerThemeChange"));
  };
  return (
    <>
      <div className="bg-background text-foreground min-h-screen">
        <header className="px-4 lg:px-6 h-14 flex items-center border-b border-gray-200 dark:border-gray-800">
          <a href="/" className="flex items-center justify-center">
            {/* <Ship className="w-6 h-6" /> */}
            {/* <img src={Logo} alt="AptFleet Logo" className="h-8 w-auto" /> */}
            <ReactSVG src={Logo} className="h-8 w-auto" />
            <span className="ml-2 text-lg font-bold">AptFleet</span>
          </a>
          <nav className="ml-auto flex gap-4 sm:gap-6">
            <a
              className="text-sm font-medium hover:underline underline-offset-4"
              href="/#features"
            >
              Features
            </a>
            <a
              className="text-sm font-medium hover:underline underline-offset-4"
              href="/#pricing"
            >
              Pricing
            </a>
            <a
              className="text-sm font-medium hover:underline underline-offset-4"
              href="/#about"
            >
              About
            </a>
            <a
              className="text-sm font-medium hover:underline underline-offset-4"
              href="/contact-us"
            >
              Contact
            </a>
            <a
              className="text-sm font-medium hover:underline underline-offset-4"
              href="/beta-register"
            >
              Join the Beta
            </a>
          </nav>
          <button
            onClick={toggleTheme}
            className="ml-4 p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800"
          >
            {darkMode ? (
              <SunIcon className="w-6 h-6" />
            ) : (
              <MoonIcon className="w-6 h-6" />
            )}
          </button>
        </header>
        <main className="mx-auto">
          <h1 className="text-2xl font-semibold text-center">{title}</h1>
          {children}
        </main>
      </div>
      <CookieConsent variant="default" />
    </>
  );
};

export default NoNavPage;
